<template>
  <header class="tw-page-header page-header">
    <div class="page-header__content">
      <h1 class="tw-page-title">
        <slot name="title">{{ title }}</slot>
      </h1>
      <p v-if="subtitle || $slots.subtitle" class="tw-page-subtitle">
        <slot name="subtitle">{{ subtitle }}</slot>
      </p>
    </div>
    <div v-if="$slots.actions" class="page-header__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.page-header__content {
  min-width: 0;
}

.page-header__actions {
  display: flex;
  align-items: center;
  gap: $space-3;
}
</style>
